import React, { useEffect } from "react";
import { Languages } from "lucide-react";
import { useTranslation } from "react-i18next";

const ALLOWED_LANGUAGES = ["en", "ja"];

const LanguageSelector = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    if (!ALLOWED_LANGUAGES.includes(i18n.language)) {
      i18n.changeLanguage("en");
      localStorage.setItem("pubmed-search-language", "en");
    }
  }, [i18n]);

  const handleLanguageChange = (e) => {
    const newLang = e.target.value;
    i18n.changeLanguage(newLang);
    // Also update localStorage for persistence
    localStorage.setItem("pubmed-search-language", newLang);
  };

  return (
    <div className="flex items-center space-x-2 bg-white/70 backdrop-blur-md rounded-full px-3 py-1.5 sm:px-4 sm:py-2 border border-gray-200 shadow-sm hover:shadow-md transition-all">
      <Languages className="h-4 w-4 text-violet-500" />
      <select
        value={ALLOWED_LANGUAGES.includes(i18n.language) ? i18n.language : "en"}
        onChange={handleLanguageChange}
        className="text-xs sm:text-sm border-0 bg-transparent focus:ring-0 focus:outline-none cursor-pointer font-medium text-gray-700 pr-2"
      >
        <option value="en">🇺🇸 English</option>
        <option value="ja">🇯🇵 日本語</option>
      </select>
    </div>
  );
};

export default LanguageSelector;
